 
const ConsignmentActions = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        // console.log("MAP Icon ", props)
        // props.context.componentParent.onCloseUploadDiv(e);
        // props.context.componentParent.onCloseRouteDiv(e);
        props.context.onShowBreaksDownData(props);
    };

    return (
            <a onClick={handleRouteClick}  title="Break Down"><i className="fa fa-truck f20"></i>&nbsp;</a>
        
    );
};

export default ConsignmentActions;
